/**
 * Navigate within the Directory page by switching tabs and opening a detail drawer.
 */
export function navigateDirectory(tab: "contacts" | "organizations" | "properties", detailId?: number) {
    window.dispatchEvent(new CustomEvent("directory:navigate", { detail: { tab, detailId } }));
}
